import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import processingIcon from "../../../../../assets/design-revamp-company/company-detail-headers/processing-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductProcessIntermediateTotal,
  createSystemBoundaryProductProcessIntermediate,
} from "../../../../../apis/Product/ProcessIntermediateSoldApi";

const ProcessIcon = () => (
  <img
    src={processingIcon}
    alt="Processing Intermediate Icon"
    width={76}
    height={76}
  />
);

const ProcessingSoldHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjProcessing, setTotalObjProcessing] = useState([]);
  const [systemBoundaryProcess, setSystemBoundaryProcess] = useState("");
  useEffect(() => {
    getProductProcessIntermediateTotal({
      id: productId,
      setProdInv: setTotalObjProcessing,
      setSystemBoundary: setSystemBoundaryProcess,
    });
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`processing-sold-category ${className || ""}`}
      leftBoxProps={{
        icon: <ProcessIcon />,
        title: t("PROCESSING_SOLD_INTERMEDIATE"),
        description: t("PROCESS_INTERMEDIATE_DESC"),
        isSystemBoundary: true,
        systemBoundary: systemBoundaryProcess,
        setSystemBoundary: setSystemBoundaryProcess,
        productId: productId,
        createSystemBoundaryFunc:
          createSystemBoundaryProductProcessIntermediate,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalObjProcessing
                        ? handleToFixedNum(
                            totalObjProcessing,
                            totalObjProcessing?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjProcessing?.updated_at
          ? formatDate(totalObjProcessing?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProcessingSoldHeader;
